module.exports = __webpack_public_path__ + "img/icon_img_06.d0d58eb9.png";